<template>
    <v-container fluid>
        <v-dialog v-model="plannedTaskPhaseListDialog" scrollable persistent>
            <PlannedTaskPhaseList
                :key="plannedTaskPhaseListComponentKey"
                ref="plannedTaskPhaseListRef"
                :title="plannedTaskPhaseListDialogTitle"
                :totalSpaceM2="selectedDepartmentSpaceM2"
                :selectedPlanFolderID="selectedPlanFolderID"
                :selectedPlanFolderName="selectedPlanFolderName"
                :initSelectedYear="selectedYear"
                :initSelectedWeek="selectedWeek"
                :initSelectedGreenhouseId="selectedGreenhouseId"
                :initSelectedGreenhouseDepartmentId="
                    selectedGreenhouseDepartmentId
                "
                :initSelectedGreenhouseDepartmentSectionId="
                    selectedGreenhouseDepartmentSectionId
                "
                :initSelectedIsSalePhase="selectedIsSalePhase"
                v-on:onPlannedTaskCreated="onPlannedTaskCreated()"
                v-on:onPlannedTaskDeleted="onPlannedTaskDeleted()"
                v-on:onClosePlannedTaskPhaseList="
                    closeSectionplannedTaskPhaseListDialog()
                "
            ></PlannedTaskPhaseList>
        </v-dialog>
        <v-row v-for="department in departmentList" :key="department.id">
            <v-col cols="12">
                <v-lazy
                    :options="{
                        threshold: 0.5
                    }"
                    min-height="200"
                    transition="fade-transition"
                >
                    <v-hover>
                        <template v-slot="{ hover }">
                            <v-card :elevation="hover ? 6 : 3">
                                <!-- header -->
                                <v-row class="mx-0 px-0 pt-3">
                                    <v-col class="col-7 pl-3" align="start">
                                        <span class="title ml-2">{{
                                            department.name
                                        }}</span>
                                        <span class="caption ml-2 pt-2"
                                            >({{
                                                department.totalSpaceM2
                                            }}
                                            m2)</span
                                        >
                                        <v-spacer></v-spacer>
                                    </v-col>
                                    <v-col class="col-5" align="end">
                                        <v-tooltip bottom>
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-btn
                                                    small
                                                    outlined
                                                    color="primary"
                                                    v-on="on"
                                                    @click="
                                                        openDepartmentSectionListDialog(
                                                            department
                                                        )
                                                    "
                                                >
                                                    <v-icon>view_module</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>View sections</span>
                                        </v-tooltip>
                                        <v-tooltip bottom>
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-btn
                                                    small
                                                    outlined
                                                    class="ml-2"
                                                    color="primary"
                                                    v-on="on"
                                                    @click="
                                                        openPlannedTaskPhaseListDialog(
                                                            department
                                                        )
                                                    "
                                                >
                                                    <v-icon>list</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>View plan list</span>
                                        </v-tooltip>
                                    </v-col>
                                </v-row>
                                <!-- chart -->
                                <div class="px-3 pt-0">
                                    <v-row align="center" class="mx-0">
                                        <v-col cols="12" class="pt-0">
                                            <div id="chart">
                                                <apexchart
                                                    type="bar"
                                                    height="200"
                                                    :options="
                                                        department.chartOptions
                                                    "
                                                    :series="department.series"
                                                ></apexchart>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </div>

                                <slot name="footer"></slot>
                            </v-card>
                        </template>
                    </v-hover>
                </v-lazy>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import PlannedTaskPhaseList from "@/components/planner/PlannedTaskPhaseList.vue";

export default {
    name: "greeenhouse-department-planned-space-list",
    components: {
        apexchart: VueApexCharts,
        PlannedTaskPhaseList: PlannedTaskPhaseList
    },
    props: [
        "greenhouseDepartmentSet",
        "selectedYear",
        "selectedPlanFolderID",
        "selectedPlanFolderName"
    ],
    data() {
        return {
            plannedTaskPhaseListDialog: false,
            plannedTaskPhaseListComponentKey: 0,

            plannedTaskPhaseListDialogTitle: null,
            selectedDepartmentSpaceM2: null,
            selectedWeek: null,
            selectedGreenhouseId: null,
            selectedGreenhouseDepartmentId: null,
            selectedGreenhouseDepartmentSectionId: null,
            selectedIsSalePhase: null,

            defaultChartOptions: {
                // chart: {
                //     id: "greenhouse-department-space-chart",
                //     type: "bar",
                //     height: 200,
                //     stacked: true,
                //     toolbar: {
                //         show: false
                //     },
                //     events: {
                //         dataPointSelection: (event, chartContext, config) => {
                //             console.log(event, chartContext, config);

                //             this.$emit(
                //                 "week-selected",
                //                 config.dataPointIndex + 1
                //             );
                //         }
                //     },
                //     animations: {
                //         enabled: false
                //     }
                // },
                xaxis: {
                    // tickPlacement: 'on',
                    type: "numeric",
                    categories: [
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14,
                        15,
                        16,
                        17,
                        18,
                        19,
                        20,
                        21,
                        22,
                        23,
                        24,
                        25,
                        26,
                        27,
                        28,
                        29,
                        30,
                        31,
                        32,
                        33,
                        34,
                        35,
                        36,
                        37,
                        38,
                        39,
                        40,
                        41,
                        42,
                        43,
                        44,
                        45,
                        46,
                        47,
                        48,
                        49,
                        50,
                        51,
                        52,
                        53
                    ]
                },
                yaxis: {
                    labels: {
                        formatter: function(val) {
                            return val.toFixed(0);
                        }
                    },
                    title: {
                        text: "m2"
                    },
                    max: 2000 //default value, will be updated by greenhouse total space
                },
                fill: {
                    opacity: 1
                },
                dataLabels: {
                    enabled: false
                },
                colors: ["#00E396", "#FEB018"],
                legend: {
                    position: "top",
                    horizontalAlign: "left",
                    offsetX: 0,
                    offsetY: 0
                }
            }
        };
    },
    computed: {
        departmentList() {
            if (!this.greenhouseDepartmentSet.edges) {
                return [];
            }

            var _departmentList = this.greenhouseDepartmentSet.edges.map(
                department => {
                    //// get department chart series
                    const _growingSpaceArray = this.defaultChartOptions.xaxis.categories.map(
                        item => {
                            const a = department.node.greenhouseDepartmentPlannedSpaceSet.edges.find(
                                e => {
                                    return e.node.taskWeek == item;
                                }
                            );
                            return a ? a.node.growthSpaceM2 : 0;
                        }
                    );

                    const _salesSpaceArray = this.defaultChartOptions.xaxis.categories.map(
                        item => {
                            const a = department.node.greenhouseDepartmentPlannedSpaceSet.edges.find(
                                e => {
                                    return e.node.taskWeek == item;
                                }
                            );

                            return a ? a.node.salesSpaceM2 : 0;
                        }
                    );

                    const _series = [
                        { name: "Growing", data: _growingSpaceArray },
                        { name: "Sales", data: _salesSpaceArray }
                    ];

                    //// get department chartOptions

                    // find max space value
                    var _totalSpaceArray = this.defaultChartOptions.xaxis.categories.map(
                        item => {
                            return (
                                _growingSpaceArray[item - 1] +
                                _salesSpaceArray[item - 1]
                            );
                        }
                    );

                    const _maxSeriesValue = Math.max(
                        ..._totalSpaceArray,
                        department.node.totalSpaceM2
                    );

                    const _chartOptions = {
                        ...this.defaultChartOptions,
                        chart: {
                            id: "greenhouse-department-space-chart",
                            type: "bar",
                            height: 200,
                            stacked: true,
                            toolbar: {
                                show: false
                            },
                            zoom: {
                                enabled: false
                            },
                            events: {
                                dataPointSelection: (
                                    event,
                                    chartContext,
                                    config
                                ) => {
                                    this.onChartWeekSelected(
                                        department.node,
                                        config.seriesIndex,
                                        config.dataPointIndex + 1
                                    );
                                }
                            },
                            animations: {
                                enabled: false
                            }
                        },
                        ...{
                            annotations: {
                                yaxis: [
                                    {
                                        y: department.node.totalSpaceM2, //default value, will be updated by greenhouse total space
                                        borderColor: "#eb4034",
                                        label: {
                                            borderColor: "#eb4034",
                                            style: {
                                                color: "#fff",
                                                background: "#eb4034"
                                            },
                                            text: "100%"
                                        }
                                    }
                                ]
                            }
                        },
                        ...{
                            yaxis: {
                                labels: {
                                    formatter: function(val) {
                                        return val.toFixed(0);
                                    }
                                },
                                title: {
                                    text: "m2"
                                },
                                max: _maxSeriesValue //default value, will be updated by greenhouse total space
                            }
                        }
                    };
                    return {
                        id: department.node.id,
                        name: department.node.name,
                        totalSpaceM2: department.node.totalSpaceM2,
                        series: _series,
                        chartOptions: _chartOptions
                    };
                }
            );
            return _departmentList;
        }
    },
    watch: {},
    methods: {
        onPlannedTaskCreated() {
            // refresh phase list
            // this.getSectionPlannedTaskPhases(this.selectedSection);

            // refresh section charts
            this.$emit("onPlannedTaskCreated");
        },
        onPlannedTaskDeleted() {
            // refresh phase list
            // this.getSectionPlannedTaskPhases(this.selectedSection);

            // refresh section charts
            this.$emit("onPlannedTaskDeleted");
        },

        // open dialog by click chart
        onChartWeekSelected(department, serialIndex, week) {
            this.plannedTaskPhaseListDialogTitle = department.name;
            this.selectedDepartmentSpaceM2 = department.totalSpaceM2;
            this.selectedGreenhouseDepartmentId = department.id;
            this.selectedWeek = week;
            this.selectedIsSalePhase = serialIndex == 0 ? false : true;

            // force vue rerender component
            this.plannedTaskPhaseListComponentKey += 1;
            // show dialog
            this.plannedTaskPhaseListDialog = true;
        },

        // open dialog by click right top button
        openPlannedTaskPhaseListDialog(department) {
            this.plannedTaskPhaseListDialogTitle = department.name;
            this.selectedDepartmentSpaceM2 = department.totalSpaceM2;
            this.selectedGreenhouseDepartmentId = department.id;
            this.selectedWeek = null;
            this.selectedIsSalePhase = null;

            // update component key to force vue rerender component
            this.plannedTaskPhaseListComponentKey += 1;
            this.plannedTaskPhaseListDialog = true;
        },

        closeSectionplannedTaskPhaseListDialog() {
            this.plannedTaskPhaseListDialog = false;
        },

        openDepartmentSectionListDialog(department) {
            this.$emit("openDepartmentSectionListDialog", department);
        }
    }
};
</script>